import React, { Component } from 'react';
import { isEmpty } from '../../Common/Common';

import Switch from '../../Part_Sample/Switch';
import Button from '../../Part_Sample/Button';
import Management_Point_Selection_Cell from '../../Part_Sample/Management_Point_Selection_Cell';

export default class Collapsible_Point_Selection extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {

		let card_style = {
			background: 'white',
			borderRadius: 20,
			padding: 10,
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 10,
		}

		let collapsible_style = {
			background: 'white',
			borderRadius: 20,
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			maxHeight: this.props.is_show ? this.props.max_height : 0,
			transition: 'max-height 0.6s ease-out',
			overflow: 'hidden'
		}

		let cell_style = {
			width: this.props.width - 110,
			margin: 5,
			padding: 10,
			backgroundColor: 'white',
			borderRadius: 20,
			border: '1px solid black',
		}

		/*
		 * this.props
		 * is_disabled - whether the entire category is disabled
		 * is_show - whether to open collapsible to show
		 * selected_points - all points that were currently selected
		 * disabled_points - all other points that should be disabled
		 * handleTogglePoints - callback function to pass the point_id of user selected point
		 */

		return (
			<div style={collapsible_style}>
				<div style={{ height: this.props.max_height - 10, overflow: 'auto', marginTop: 10 }}>
					{Object.keys(this.props.points_selection).map((point_id) => {
						let point_info = window.app.state.point_list[point_id];
						if (!isEmpty(point_info)) {
							return (
								<Management_Point_Selection_Cell
									cell_style={cell_style}
									id={point_id}
									height={this.props.height}
									width={this.props.width}
									key={point_id}
									handleSetToggle={this.props.handleTogglePoints}
									point_info={point_info}
									is_selected={this.props.selected_points.includes(point_id)}
									is_disabled={this.props.is_disabled || this.props.disabled_points.includes(point_id)}
								/>
							)
						}
					})}
					<div style={{ opacity: 0.2 }}>
						{this.props.selected_points.map((point_id) => {
							let point_info = window.app.state.point_list[point_id];
							// If the point id does not exist in current point_list
							if (isEmpty(point_info)) {
								point_info = {};
								point_info.name = point_id;
								return (
									<Management_Point_Selection_Cell
										cell_style={cell_style}
										width={this.props.width}
										id={point_id}
										key={point_id}
										handleSetToggle={this.props.handleTogglePoints}
										point_info={point_info}
										is_selected={true}
										is_disabled={false}
									/>
								)
							}
						})}
					</div>
				</div>
			</div>
		)
	}
}